import _, {isNil} from 'lodash';
import React from 'react';
import {Button} from 'react-bootstrap';
import {batch} from 'react-redux';
import {
  showTipsPickupCalibrationAbortedToast,
  tipsPickupCalibrationErrorHandler,
} from 'contents/HardwareSettings/TipsPickupCalibration/tipsPickupCalibrationErrorHandlerBusiness';
import {
  setTipsPickupIsRecentlyCalibrated,
  setTipsPickupLastCalibratedDate,
  setTipsPickupPosition,
} from 'stores/actions/headStateAction';
import {parseMessage} from 'lib/stringHelper';
import {
  isTipsPickupCalibrationExecutor,
  runAutoA1OffsetCalibrationAndShowLoading,
} from 'contents/HardwareSettings/TipsPickupCalibration/TipsPickupCalibrationBusiness';

import {setSelectedWellStyle} from 'stores/actions/reteachPlateAction';
import {setEStopTriggered, setInstrumentStatus, setMotorErrorData} from 'stores/actions/instrumentAction';
import {setIsPlateRecognitionEnabled} from 'stores/actions/plateRecognitionAction';
import FormattedHTMLMessage from '../../../components/FormattedHTMLMessage';

import {
  closeRuntimeViewHandler,
  fastRuntimeErrorResHandling,
  onProtocolExecutionCompletelyFinished,
  onProtocolExecutionDoneInstrumentMoveToIdle,
  reRunRunningProtocol,
  recoverRunningProtocol,
  showRuntimeUserActionModalByLastExecutedTask,
  showRuntimeUserActionModalByTaskType,
} from '../runtimeBusiness';
import {invokeAPI, resolveIntl, setErrorCodeNumber} from '../commonBusiness';
import {abortActionBatch, resumeProtocol} from '../instrumentBusiness';
import {
  abortPauseResponseHandler,
  resumeResponseHandler,
  showRunningProtocolWillTakeMoreTime,
  showRuntimePausedModal,
  showTipsNotEnoughPartiallyModal,
  showTipsNotEnoughPartiallyYouHaveNoChoiceModal,
} from '../runtimeModalBusiness';
import {showModalConnectionLost} from '../commonModalBusiness';
import {removeTemporaryState} from '../../actions/temporaryStateAction';

import {
  changeView,
  showLoading,
  hideLoading,
  showSnackbar,
  hideSnackbar,
  resetIsManualReteachPage,
} from '../../actions/appStateAction';
import {
  setCardIsExpanded,
  setCardIsSelected,
  setGroupIsExpanded,
  setGroupIsSelected,
} from '../../actions/cardStateAction';
import {showModal, hideModal} from '../../actions/modalStateAction';
import {
  setRuntimeProgress,
  setPausedOn,
  setRuntimeStatus,
  setCsvRecordID,
  showRuntimeDialog,
  addDoneRecord,
  hideRuntimeDialog,
  resetRuntimeState,
  addOnProgressRecord,
  removeOnProgressRecord,
  setReadOnly,
  setExecutionCount,
  setRuntimePauseRemainingTime,
} from '../../actions/runtimeStateAction';
import {setLicense} from '../../actions/licenceStateAction';

import {updateLabwareCurrentRunProtocol} from '../protocolManagementBusiness';
import {resetPlateTypeEditorState} from '../../actions/plateTypeEditorStateAction';

import {
  SignalREvent,
  SignalRHub,
  FastRobotErrorcode,
  ViewMode,
  RuntimeMode,
  TaskType,
  Feedback,
  UserRoleLevel,
  ModalType,
  InstrumentStatusType,
} from '../../../constants/dataEnum';

import jsonCopy from '../../../lib/jsonCopy';

import {setLabwareState} from '../../actions/labwareStateAction';
import {setAutoA1OffsetCalibrationProgress, setWizardFlag} from '../../actions/wizardStateAction';
import {isProtocolExecutor, saveState} from '../stateBusiness';
import {
  checkOngoingCalibration,
  gettingAndSetInstalledTray,
  handleTrayCalibrationErrorResponse,
  onAutoCalibration,
  setTrayCalibrationResult,
} from '../trayCalibrationBusiness';
import {autoCalibrationErrorHandler} from '../errorHandlerBusiness';
import {showEmergencyStopModal} from '../emergencyStopBusiness';
import {fastRecovery} from '../recoveryBusiness';
import {SetupWizardStep, WizardFlag} from '../../../constants/SetupWizardEnum';
import {
  getSetupWizardFlagMessage,
  setCurrentStepAsProcessed,
  setStepDataByName,
} from '../setupWizardBusiness/commonSetupWizardBusiness';
import {
  checkTraySuitabilitySetupWizard,
  handleSetMarkerPositionAfterUpdateA1,
  handleSWizardAutoCalibrationResponse,
} from '../setupWizardBusiness/setupWizardInstrumentBusiness';
import {setShowSetTipModal} from '../../actions/tipStateAction';
import {kickUser} from '../softwareUpdaterBusiness';
import {setProtocolStateRunningProtocol} from '../../actions/protocolExplorerAction';
import {setIsTrayAttached} from '../../actions/trayCalibrationStateAction';
import {
  handlePostMissingTrayScanTrayId,
  onTrayDetached,
} from '../../../components/Modal/missingTrayModal/missingTrayBusiness';
import {setLatestSignalREventReceived} from '../../actions/signalrStateAction';
import {updateLabwareDefinition} from '../labwareDatabaseBusiness';
import {showLoadCellErrorModal} from '../loadCellErrorBusiness';
import {
  checkOngoingManualReteachProcess,
  openManualReteachPage,
} from '../manualReteachPlateBusiness/manualReteachPlateBusiness';
import {manualReteachErrorHandler} from '../errorHandlers/manualReteachErrorHandler';
import {exitPlateTypeEditor} from '../plateTypeEditorBusiness';
import {showMotorSkipModal} from '../modalStateBusinessAction';
import {checkIsInstrumentIdle} from '../instrumentStatusBusiness';

const intl = resolveIntl();

const isEventCalledOnce = (event) => (dispatch, getState) => {
  const {latestEventReceived} = getState().signalrState;

  if (latestEventReceived === event) return false;

  dispatch(setLatestSignalREventReceived(event));
  return true;
};

const handleCollisionRecovery = (errorCode) => async (dispatch, getState) => {
  if (errorCode === FastRobotErrorcode.NoError) {
    const {instrumentState} = getState();
    const {motorErrorData} = instrumentState;
    const {mustReleaseTip} = motorErrorData;

    dispatch(resumeResponseHandler(mustReleaseTip));
  } else {
    dispatch(fastRuntimeErrorResHandling(errorCode));
  }
};

export const subscribeEvent = (hubObject) => (dispatch, getState) => {
  let movingToIdleLoading = false;
  hubObject.onclose(() => {
    console.log('connection is closed - instrument hub');
    const {aboutState, appState} = getState();
    const {isUpdating, isDowngrading} = aboutState;
    const {isRestoringSoftware} = appState;

    if (isUpdating) {
      const loadingElement = (
        <div>
          <div style={{marginTop: '60px'}}>
            <FormattedHTMLMessage id="about.updaterLoading.connectionHasClosed.text" />
          </div>
          <Button
            className="button-primary"
            style={{marginTop: '50px'}}
            onClick={() => {
              window.location.reload();
            }}
          >
            {intl.formatMessage({id: 'about.updaterLoading.connectionHasClosed.button'})}
          </Button>
        </div>
      );

      dispatch(showLoading(loadingElement));
    } else if (!isDowngrading && !isRestoringSoftware) {
      dispatch(hideSnackbar());
      dispatch(hideLoading());
      dispatch(showModalConnectionLost());
    }
  });

  hubObject.onreconnecting(() => {
    console.log('onreconnecting...');
    const {aboutState, appState} = getState();
    const {isFinalizing, isDowngrading} = aboutState;
    const {isRestoringSoftware} = appState;

    if (isFinalizing || isDowngrading || isRestoringSoftware) {
      return;
    }

    dispatch(hideLoading());
    dispatch(showSnackbar(Feedback.INFO, intl.formatMessage({id: 'connection.message.onreconnecting'})));
  });

  hubObject.onreconnected(() => {
    console.log('onreconnected!');
    const {appState, runtimeState} = getState();
    const {viewMode} = appState;
    const {reportVisible} = runtimeState;

    if (viewMode === ViewMode.RUNTIME) {
      dispatch(recoverRunningProtocol(reportVisible, viewMode));
      dispatch(hideSnackbar());
    }
  });

  // VisionScanDone will triger after scanning caddy or tips are done
  hubObject.on(SignalREvent.VISION_SCAN_DONE, async (res) => {
    console.info('event received:', SignalREvent.VISION_SCAN_DONE);
    console.log(SignalREvent.VISION_SCAN_DONE, res);

    // dispatch(hideLoading());
  });

  // SetTipsCaddyDone will triger after setting tips caddy is done
  hubObject.on(SignalREvent.SET_TIPS_CADDY_DONE, async (res) => {
    console.info('event received:', SignalREvent.SET_TIPS_CADDY_DONE);
    console.log(SignalREvent.SET_TIPS_CADDY_DONE, res);

    // centralized hiding the loading screen on event PROTOCOL_CALCULATION_DONE

    // if (res.errCode === FastRobotErrorcode.NoError && viewMode !== ViewMode.SETUP_WIZARD) {
    //   dispatch(hideLoading());
    // }
  });

  // VisionScanTrayIdDone will triger after scanning tray is done
  hubObject.on(SignalREvent.VISION_SCAN_TRAY_DONE, async (res) => {
    const isCalledOnce = dispatch(isEventCalledOnce(SignalREvent.VISION_SCAN_TRAY_DONE));
    if (!isCalledOnce) return;

    console.info('event received:', SignalREvent.VISION_SCAN_TRAY_DONE);
    console.log(SignalREvent.VISION_SCAN_TRAY_DONE, res);
    const {appState, temporaryState, typedModalState} = getState();
    const {viewMode} = appState;

    if (viewMode === ViewMode.SETUP_WIZARD) {
      dispatch(checkTraySuitabilitySetupWizard());
    } else {
      await dispatch(gettingAndSetInstalledTray());

      // missing tray logic will be handled on event TrayAttachedHandlingDone when the tray is truly idle
      if (typedModalState.modalType === ModalType.MissingTray) return;
    }

    // centralized hiding the loading screen on event PROTOCOL_CALCULATION_DONE

    // if (
    //   viewMode !== ViewMode.PROTOCOL_EDITOR &&
    //   viewMode !== ViewMode.TRAY_CALIBRATION &&
    //   viewMode !== ViewMode.SETUP_WIZARD
    // ) {
    //   dispatch(hideLoading());
    // }

    if (temporaryState?.errorModal?.errorCode === FastRobotErrorcode.MissingTray) {
      dispatch(removeTemporaryState('errorModal'));
      dispatch(hideModal());
    }
  });

  // ProtocolCalculationDone will get triggered after backend has finished calculating tip pickup positions
  hubObject.on(SignalREvent.PROTOCOL_CALCULATION_DONE, async (res) => {
    console.info('event received:', SignalREvent.PROTOCOL_CALCULATION_DONE);
    console.log(SignalREvent.PROTOCOL_CALCULATION_DONE, res);
    const {appState} = getState();
    const {loading, viewMode} = appState;

    if (viewMode === ViewMode.RUNTIME && loading.show) {
      dispatch(hideLoading());
    }
  });

  // SetProtocolTip will triger after set tip posisition
  hubObject.on(SignalREvent.SET_PROTOCOL_TIP, async ({errorCode, deckInsertID, requiredTips, availableTips}) => {
    console.info('event received:', SignalREvent.SET_PROTOCOL_TIP);
    console.log(SignalREvent.SET_PROTOCOL_TIP, errorCode, deckInsertID);

    await setErrorCodeNumber(errorCode);

    switch (errorCode) {
      case FastRobotErrorcode.TipsNotEnough:
      case FastRobotErrorcode.TipsNeedArrangement:
      case FastRobotErrorcode.TipsNotEnoughPartially:
      case FastRobotErrorcode.TIPS_NOT_ENOUGH_PARTIALLY_UNREACHABLE:
      case FastRobotErrorcode.TipsNotEnoughPartiallyYouHaveNoChoice: {
        const isExecutor = await dispatch(isProtocolExecutor());

        if (!isExecutor) {
          return;
        }

        break;
      }

      default:
        break;
    }

    switch (errorCode) {
      case FastRobotErrorcode.NoError: {
        dispatch(resumeProtocol(false, false, true));
        break;
      }
      case FastRobotErrorcode.TipsNeedArrangement: {
        dispatch(hideLoading());
        const {tipState} = getState();
        const tipAmount = tipState.selectedTip.length;
        let buttons = [
          {
            className: 'btn-lg',
            style: 'secondary',
            handlerClick: () => {
              dispatch(resumeProtocol(false, false, true));
              dispatch(hideModal());
            },
            text: intl.formatMessage({
              id: 'instrumentControlHubBusiness.rearrangeTipModal.secondButton',
            }),
          },
        ];
        if (tipAmount < 384) {
          buttons = [
            {
              className: 'btn-lg',
              style: 'primary',
              handlerClick: () => {
                dispatch(hideModal());
                dispatch(setShowSetTipModal(true));
              },
              text: intl.formatMessage({
                id: 'instrumentControlHubBusiness.rearrangeTipModal.firstButton',
              }),
            },
            {
              className: 'btn-lg',
              style: 'secondary',
              handlerClick: () => {
                dispatch(resumeProtocol(false, false, true));
                dispatch(hideModal());
              },
              text: intl.formatMessage({
                id: 'instrumentControlHubBusiness.rearrangeTipModal.secondButton',
              }),
            },
          ];
        }
        dispatch(
          showModal(
            intl.formatMessage({
              id: 'instrumentControlHubBusiness.rearrangeTipModal.title',
            }),
            <div>
              {intl.formatMessage({
                id: 'instrumentControlHubBusiness.rearrangeTipModal.message',
              })}
              <br />
              <br />
              {tipAmount < 384 && (
                <p>
                  {intl.formatMessage({
                    id: 'instrumentControlHubBusiness.rearrangeTipModal.conditionalMessageFullCaddy',
                  })}
                </p>
              )}
            </div>,
            buttons,
            () => dispatch(hideModal()),
            '',
            true,
          ),
        );
        break;
      }
      case FastRobotErrorcode.TipsNotEnough: {
        dispatch(hideLoading());
        dispatch(
          showModal(
            intl.formatMessage({
              id: 'instrumentControlHubBusiness.setProtocolTips.tipsNotEnoughMessageModal.title',
            }),
            <div>
              {intl.formatMessage({
                id: 'instrumentControlHubBusiness.setProtocolTips.tipsNotEnoughMessageModal.message',
                values: {requiredTips},
              })}
            </div>,
            [
              {
                className: 'btn-lg',
                style: 'primary',
                handlerClick: () => {
                  dispatch(hideModal());
                  dispatch(setShowSetTipModal(true));
                },
                text: intl.formatMessage({
                  id: 'instrumentControlHubBusiness.setProtocolTips.tipsNotEnoughMessageModal.firstButton',
                }),
              },
              {
                className: 'btn-lg',
                style: 'primary',
                handlerClick: () => {
                  dispatch(hideModal());
                  dispatch(abortActionBatch());
                },
                text: intl.formatMessage({
                  id: 'instrumentControlHubBusiness.setProtocolTips.tipsNotEnoughMessageModal.secondButton',
                }),
              },
            ],
            () => dispatch(hideModal()),
            'modal-tip-not-enough',
            true,
          ),
        );
        break;
      }
      case FastRobotErrorcode.TipsNotEnoughPartially: {
        dispatch(hideLoading());
        dispatch(showTipsNotEnoughPartiallyModal(requiredTips, availableTips));
        break;
      }
      case FastRobotErrorcode.TipsNotEnoughPartiallyYouHaveNoChoice: {
        dispatch(hideLoading());
        dispatch(showTipsNotEnoughPartiallyYouHaveNoChoiceModal(requiredTips, availableTips));
        break;
      }
      case FastRobotErrorcode.MissingTray: {
        dispatch(hideLoading());
        dispatch(
          showModal(
            intl.formatMessage({
              id: 'instrumentControlHubBusiness.missingTray.title',
            }),
            <FormattedHTMLMessage id="instrumentControlHubBusiness.missingTrayRun.message" />,
            [
              {
                className: 'btn-lg',
                style: 'primary',
                handlerClick: () => {
                  batch(() => {
                    dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.ABORT_PROTOCOL, true));
                    dispatch(hideModal());
                    dispatch(changeView(ViewMode.PROTOCOL_EDITOR));
                  });
                },
                text: intl.formatMessage({
                  id: 'instrumentControlHubBusiness.missingTrayRun.firstButton',
                }),
              },
            ],
            () => dispatch(hideModal()),
            'modal-tip-not-enough',
            true,
          ),
        );
        break;
      }
      case FastRobotErrorcode.UNREACHABLE_TIPS_NEED_MANUAL_ARRAGEMENT: {
        dispatch(hideLoading());
        dispatch(
          showModal(
            intl.formatMessage({
              id: 'instrumentControlHubBusiness.setProtocolTips.unReachableTipsNeedManualArragement.title',
            }),
            <div>
              {intl.formatMessage({
                id: 'instrumentControlHubBusiness.setProtocolTips.unReachableTipsNeedManualArragement.text',
              })}
            </div>,
            [
              {
                className: 'btn-lg',
                style: 'primary',
                handlerClick: () => {
                  dispatch(hideModal());
                  dispatch(setShowSetTipModal(true));
                },
                text: intl.formatMessage({
                  id: 'instrumentControlHubBusiness.setProtocolTips.unReachableTipsNeedManualArragement.firstButton',
                }),
              },
            ],
            () => dispatch(hideModal()),
            '',
            true,
          ),
        );
        break;
      }
      default: {
        dispatch(hideLoading());
        // fastCommonRunAPIResponseHandlerProps(response);
        break;
      }
    }
  });

  hubObject.on(SignalREvent.PERCENT_PROGRESS_BAR_UPDATE, (response) => {
    const {appState} = getState();
    const {viewMode} = appState;

    console.info('event received:', SignalREvent.PERCENT_PROGRESS_BAR_UPDATE);
    console.log('PercentProgress response:', response);
    if (viewMode === ViewMode.RUNTIME) {
      dispatch(setRuntimeProgress(response));
    }
  });

  // ProgressUpdate will triger when progress bar updated from back end
  hubObject.on(SignalREvent.PROGRESS_UPDATE, (response) => {
    const {appState, cardState, modalState, runtimeState, instrumentState} = getState();
    const {viewMode} = appState;
    const {readOnly} = runtimeState;
    const {instrumentStatus} = instrumentState;

    console.info('event received:', SignalREvent.PROGRESS_UPDATE);
    console.log('ProgressUpdate response:', response);

    if (instrumentStatus !== InstrumentStatusType.RUNNING) {
      dispatch(setInstrumentStatus(InstrumentStatusType.RUNNING));
    }

    if (viewMode === ViewMode.RUNTIME) {
      const {csvRecordID, result} = response;

      dispatch(setCsvRecordID(csvRecordID));

      // set selected card
      const {tasks, cards} = cardState;
      const {ID, type} = tasks[csvRecordID];

      const card = _.find(cards, (crd) => crd.tasks.includes(ID));

      if (card) {
        dispatch(setCardIsSelected(card.ID));
        dispatch(setCardIsExpanded(card.ID, true));

        if (!isNil(card.groupID)) {
          dispatch(setGroupIsSelected(card.groupID));
          dispatch(setGroupIsExpanded(card.groupID, true));
        }
      }

      // add prev record to done state
      if (result) {
        if (csvRecordID !== -1) {
          dispatch(addDoneRecord(csvRecordID));
          dispatch(removeOnProgressRecord(csvRecordID));
        }

        if (modalState.show && type === TaskType.DELAY) {
          dispatch(hideModal());
          clearInterval(modalState.timerInterval);
        }

        return;
      }

      dispatch(addOnProgressRecord(csvRecordID));

      // user confirmation modal are shown on USER_CONFIRMATION_DIALOG event to wait for the tray to be ejected
      // so user wouldn't press confirm on the modal instantly
      if (!readOnly && (type === TaskType.USER_CONFIRMATION_EJECT || type === TaskType.USER_CONFIRMATION)) {
        dispatch(showLoading(intl.formatMessage({id: 'runtime.pauseProtocolStart.loading'})));
      }
    }
  });

  // RuntimeError will triger when there is collision or motor skip and also after tip run out in the middle of run
  hubObject.on(SignalREvent.RUNTIME_ERROR, async (response) => {
    console.info('event received:', SignalREvent.RUNTIME_ERROR);
    console.log('RuntimeError response:', response);
    const {appState, runtimeState} = getState();
    const {viewMode, loading} = appState;
    const isExecutor = await dispatch(isProtocolExecutor());

    if (loading.show && viewMode !== ViewMode.SETUP_WIZARD) dispatch(hideLoading());

    dispatch(setInstrumentStatus(InstrumentStatusType.PAUSED));

    const {errorCode, lastExecutedTask} = response;

    if (
      (viewMode === ViewMode.RUNTIME &&
        (!runtimeState.readOnly || errorCode === FastRobotErrorcode.ActuatorEmergencyStop)) ||
      (viewMode === ViewMode.SETUP_WIZARD && isExecutor)
    ) {
      dispatch(setPausedOn(lastExecutedTask));
      dispatch(setRuntimePauseRemainingTime(true));
      dispatch(setRuntimeStatus(RuntimeMode.PAUSED));
      dispatch(fastRuntimeErrorResHandling(errorCode, response));
      // appStateAction.saveState();
    }
  });

  // PauseProtocolStart will triger when user start pauseS
  hubObject.on(SignalREvent.PAUSE_PROTOCOL_START, () => {
    console.info('event received:', SignalREvent.PAUSE_PROTOCOL_START);
    console.log('PauseProtocolStart');
    const {appState} = getState();
    const {viewMode} = appState;
    if (viewMode === ViewMode.RUNTIME) {
      dispatch(hideRuntimeDialog());
      dispatch(setRuntimeStatus(RuntimeMode.PAUSING));
      dispatch(showLoading(intl.formatMessage({id: 'runtime.pauseProtocolStart.loading'})));
      // const dialog = {
      //   type: Feedback.INFO,
      //   headerText: (
      //     <p>
      //       <FormattedHTMLMessage
      //         id="runtimeNotification.pausing.headerText"
      //       />
      //     </p>
      //   ),
      // };

      // dispatch(showRuntimeDialog(dialog));
    }
  });

  // PauseProtocolEnd will triger when pause proses is done
  hubObject.on(SignalREvent.PAUSE_PROTOCOL_END, async (response) => {
    console.info('event received:', SignalREvent.PAUSE_PROTOCOL_END);
    console.log('PauseProtocolEnd response:', response);
    const {appState, modalState} = getState();
    const {viewMode, loading} = appState;

    dispatch(setInstrumentStatus(InstrumentStatusType.PAUSED));

    if (viewMode === ViewMode.RUNTIME) {
      const {lastExecutedTask, isHardPause, usernameRequester} = response || {};

      if (modalState.show && !isHardPause) dispatch(hideModal());
      if (loading.show) dispatch(hideLoading());
      console.log('PauseProtocolEnd', response);
      dispatch(setRuntimeStatus(RuntimeMode.PAUSED));

      if (isHardPause) {
        const {errorCodeNumber} = modalState;
        if (errorCodeNumber === 0) dispatch(abortPauseResponseHandler(lastExecutedTask, null, usernameRequester));
        // appStateAction.saveState();
      } else {
        const isShowingModal = await dispatch(showRuntimeUserActionModalByLastExecutedTask(lastExecutedTask));

        if (!isShowingModal) dispatch(showRuntimePausedModal());
        dispatch(setPausedOn(lastExecutedTask));
        dispatch(setRuntimeStatus(RuntimeMode.PAUSED));
        // appStateAction.saveState();
      }
    }
  });

  // ResumeProtocolStart will triger when user start resume protocol execution
  hubObject.on(SignalREvent.RESUME_PROTOCOL_START, async (isRecovery) => {
    console.info('event received:', SignalREvent.RESUME_PROTOCOL_START);
    console.log('ResumeProtocolStart response:', isRecovery);

    const {appState, cardState, runtimeState, wizardState} = getState();
    const {viewMode} = appState;
    const {stepName} = wizardState;

    if (viewMode === ViewMode.RUNTIME) {
      const {tasks, cards} = cardState;
      const {csvRecordID} = runtimeState;
      const {ID} = tasks[csvRecordID] || {};

      dispatch(hideModal());

      const card = _.find(cards, (crd) => crd.tasks.includes(ID));

      if (card) {
        dispatch(setCardIsSelected(card.ID));
      }

      dispatch(hideRuntimeDialog());

      if (isRecovery) {
        dispatch(showLoading(intl.formatMessage({id: 'instrumentControlHub.ResumeProtocolStart.loading'})));
      } else {
        dispatch(showLoading());
      }
    } else if (stepName === SetupWizardStep.PLATE_COPY_PROTOCOL) {
      const isExecutor = await dispatch(isProtocolExecutor());

      if (isExecutor) {
        const loadingMsg = dispatch(getSetupWizardFlagMessage(WizardFlag.LOADING));

        dispatch(showLoading(loadingMsg));
        dispatch(saveState());
      }
    }
  });

  // ResumeProtocolEnd will triger when resume protocol execution is done
  hubObject.on(SignalREvent.RESUME_PROTOCOL_END, async (isRecovery, isNeedScanTips, errorCode, isResume) => {
    console.info('event received:', SignalREvent.RESUME_PROTOCOL_END);
    console.log(
      'ResumeProtocolEnd:',
      isNeedScanTips,
      'ErrorCode:',
      errorCode,
      'isRecovery:',
      isRecovery,
      'isResume',
      isResume,
    );
    const {appState} = getState();
    const {viewMode, prevViewMode} = appState;

    if (isResume && errorCode === FastRobotErrorcode.NoError) {
      dispatch(setInstrumentStatus(InstrumentStatusType.RUNNING));
    }

    if (viewMode === ViewMode.SETUP_WIZARD && !isResume) {
      dispatch(handleCollisionRecovery(errorCode));
    }

    if (viewMode === ViewMode.RUNTIME) {
      if (isRecovery) {
        const dialog = {
          type: Feedback.INFO,
          headerText: {
            id: 'runtimeNotification.recoverySuccess.headerText',
            values: {},
          },
        };
        dispatch(showRuntimeDialog(dialog));
      }
      if (isNeedScanTips) {
        dispatch(
          showLoading(
            intl.formatMessage({
              id: 'runtimeBusiness.scanTip.loading',
            }),
          ),
        );
      } else {
        dispatch(hideLoading());
      }
      if (isResume) {
        if (errorCode === FastRobotErrorcode.NoError) {
          dispatch(setPausedOn(''));
          dispatch(setRuntimeStatus(RuntimeMode.RUNNING));
          dispatch(setMotorErrorData());

          const newViewMode = prevViewMode === ViewMode.SETUP_WIZARD ? ViewMode.SETUP_WIZARD : ViewMode.RUNTIME;
          const shouldChangeView = prevViewMode === ViewMode.SETUP_WIZARD || viewMode !== ViewMode.RUNTIME;

          if (shouldChangeView) {
            dispatch(changeView(newViewMode));
          }
        }
      } else if (!isResume) {
        dispatch(handleCollisionRecovery(errorCode));
      }
    }
  });

  // AbortProtocolStart will triger when System is start  Abort proses, note after Abort proses is done ProtocolDone will get triggered
  hubObject.on(SignalREvent.ABORT_PROTCOL_START, async () => {
    console.info('event received:', SignalREvent.ABORT_PROTCOL_START);
    console.log('AbortProtocolStart');
    const isExecutor = await dispatch(isProtocolExecutor());
    const {appState, runtimeState, wizardState} = getState();
    const {viewMode} = appState;
    const {status, executionCount} = runtimeState;

    if (
      viewMode === ViewMode.RUNTIME ||
      (viewMode === ViewMode.SETUP_WIZARD && wizardState.stepName === SetupWizardStep.PLATE_COPY_PROTOCOL && isExecutor)
    ) {
      await dispatch(hideModal());
      dispatch(showLoading(intl.formatMessage({id: 'instrumentControlHub.AbortProtocolStart.loading'})));

      if (executionCount > 0) dispatch(setExecutionCount(0));
    }

    if (status !== RuntimeMode.ABORTED) {
      dispatch(setRuntimeStatus(RuntimeMode.ABORTING));
    }
  });

  // ProtocolDone will triger when System is done running protocol, will start moving to idle position
  hubObject.on(SignalREvent.PROTOCOL_DONE, async (response) => {
    // TODO: find out if this can be implemented for all event received as a wrapper
    const isCalledOnce = dispatch(isEventCalledOnce(SignalREvent.PROTOCOL_DONE));
    if (!isCalledOnce) return;

    console.info('event received:', SignalREvent.PROTOCOL_DONE);
    console.log('ProtocolDone response:', response);
    movingToIdleLoading = true;

    dispatch(onProtocolExecutionDoneInstrumentMoveToIdle(response));
  });

  // ExecutionDone will triger when System is done moving to idle position
  hubObject.on(SignalREvent.EXECUTION_DONE, async (response) => {
    // TODO: find out if this can be implemented for all event received as a wrapper
    const isCalledOnce = dispatch(isEventCalledOnce(SignalREvent.EXECUTION_DONE));
    if (!isCalledOnce) return;

    console.info('event received:', SignalREvent.EXECUTION_DONE);
    console.log(SignalREvent.EXECUTION_DONE, response);
    movingToIdleLoading = false;
    console.log(movingToIdleLoading);

    const {runtimeState} = getState();
    const {executionCount} = runtimeState;

    const isExecutor = await dispatch(isProtocolExecutor());

    if (executionCount > 0 && isExecutor) {
      await dispatch(reRunRunningProtocol());
      return;
    }

    dispatch(onProtocolExecutionCompletelyFinished());
  });

  hubObject.on(SignalREvent.CLOSE_RUNTIME_VIEW, async () => {
    console.info('event received:', SignalREvent.CLOSE_RUNTIME_VIEW);
    console.log('CloseRuntimeView');

    const {isExecutor, payload} = await dispatch(isProtocolExecutor(true));

    // For executor, the runtime view will be closed after
    // pressing the close button on the runtime header.
    if (!isExecutor && payload) {
      console.log('Closing runtime view - non executor');
      dispatch(closeRuntimeViewHandler());
    }
  });

  hubObject.on(SignalREvent.NEW_RUN_SESSION, async () => {
    // TODO: find out if this can be implemented for all event received as a wrapper
    const isCalledOnce = dispatch(isEventCalledOnce(SignalREvent.NEW_RUN_SESSION));
    if (!isCalledOnce) return;

    console.info('event received:', SignalREvent.NEW_RUN_SESSION);
    console.log('NewRunSession');

    // to make sure the running protocol is up-to-date because of the
    // time gap between invoking run protocol and saving running protocol
    setTimeout(async () => {
      const {appState, sessionState, protocolState, runtimeState} = getState();
      const {viewMode, prevViewMode} = appState;
      const {executionCount} = runtimeState;

      const {userRole} = sessionState.user;

      const {isExecutor, payload} = await dispatch(isProtocolExecutor(true));
      const {user: executor, id: runnningProtocolId} = payload || {};

      dispatch(
        setReadOnly(
          !isExecutor && Number(userRole) !== UserRoleLevel.ADMINISTRATOR && Number(userRole) !== UserRoleLevel.SERVICE,
        ),
      );

      if (isExecutor) {
        dispatch(setExecutionCount(executionCount - 1));
        return;
      }

      // refresh the runtime
      if (runnningProtocolId === runtimeState.id && viewMode === ViewMode.RUNTIME) {
        await dispatch(recoverRunningProtocol());
        return;
      }

      if (
        viewMode === ViewMode.RUNTIME ||
        viewMode === ViewMode.TRAY_CALIBRATION ||
        viewMode === ViewMode.PLATE_TYPE_EDITOR
      ) {
        dispatch(hideModal());
        dispatch(changeView(prevViewMode === ViewMode.PROTOCOL_EDITOR ? ViewMode.PROTOCOL_EDITOR : ViewMode.EXPLORER));

        dispatch(resetRuntimeState());
        dispatch(resetPlateTypeEditorState());
      }

      // protocol owner currently opened the running protocol
      // (executor is operator or tessara reguler user)
      if (viewMode === ViewMode.PROTOCOL_EDITOR && runnningProtocolId === protocolState.lastOpenedProtocol?.id) {
        dispatch(showLoading(intl.formatMessage({id: 'runtimeBusiness.scanTip.loading'})));

        await dispatch(recoverRunningProtocol());
        dispatch(
          showSnackbar(
            Feedback.INFO,
            <FormattedHTMLMessage
              id="protocolEditor.toast.protocolIsBeingRun"
              values={{executor: executor?.username}}
            />,
          ),
        );
      }

      if (viewMode === ViewMode.EXPLORER) {
        dispatch(setProtocolStateRunningProtocol(payload));
      }

      dispatch(setInstrumentStatus(InstrumentStatusType.RUNNING));
    }, 3000);
  });

  // PreRunProtocolConfirmation will be triggered when user has disabled head channel(s)
  // and do a split pick up tip
  hubObject.on(SignalREvent.PRE_RUN_PROTOCOL_CONFIRMATION, async () => {
    console.info('event received:', SignalREvent.PRE_RUN_PROTOCOL_CONFIRMATION);
    const {appState} = getState();

    setTimeout(async () => {
      const isExecutor = await dispatch(isProtocolExecutor());

      if (isExecutor) {
        if (appState.loading) dispatch(hideLoading);
        dispatch(showRunningProtocolWillTakeMoreTime());
      }
    }, 3000);
  });

  hubObject.on(SignalREvent.TRAY_DETACHED, async () => {
    const isCalledOnce = dispatch(isEventCalledOnce(SignalREvent.TRAY_DETACHED));
    if (!isCalledOnce) return;

    console.info('event received:', SignalREvent.TRAY_DETACHED);

    dispatch(onTrayDetached());
  });

  hubObject.on(SignalREvent.TRAY_ATTACHED, async () => {
    console.info('event received:', SignalREvent.TRAY_ATTACHED);
    const {typedModalState, temporaryState} = getState();
    const {isShown, data} = typedModalState;
    const {errorModal} = temporaryState;

    dispatch(setIsTrayAttached(true));

    if ((isShown && !data?.isNeedRecovery) || errorModal?.errorCode === FastRobotErrorcode.MissingTray) {
      dispatch(hideModal());
    }
  });

  // TrayAttachedHandlingDone will be triggered after the instrument is idle post scanning the tray id
  hubObject.on(SignalREvent.TRAY_ATTACHED_HANDLING_DONE, async () => {
    console.info('event received:', SignalREvent.TRAY_ATTACHED_HANDLING_DONE);
    const {typedModalState} = getState();
    const {data} = typedModalState;

    // TODO: find out if this can be implemented for all event received as a wrapper
    const isCalledOnce = dispatch(isEventCalledOnce(SignalREvent.TRAY_ATTACHED_HANDLING_DONE));
    if (!isCalledOnce) return;

    if (data?.permissionChecker && !data?.permissionChecker?.isTouchProbeInitiallyExtended) {
      // if touch probe is initially extended, then the tray scanning is handled manually by UI
      // therefore, this event is triggered without the instrument scanned the tray first. do not execute the post scanning tray id action.
      dispatch(handlePostMissingTrayScanTrayId());
    }
  });

  hubObject.on(SignalREvent.EMERGENCY_STOP_TRIGGERED, async (res) => {
    const {appState} = getState();
    const {viewMode} = appState;

    console.info('event received:', SignalREvent.EMERGENCY_STOP_TRIGGERED);
    console.log(SignalREvent.EMERGENCY_STOP_TRIGGERED, res);

    const {isIdle: isAutoCalibrationIdle} = await dispatch(checkOngoingCalibration(false));

    if (!isAutoCalibrationIdle) return;

    // show emergency stop modal when instrument in idle position
    if (res.isIdle) {
      await dispatch(setErrorCodeNumber(FastRobotErrorcode.ActuatorEmergencyStop));
      dispatch(setEStopTriggered(true));
      dispatch(showEmergencyStopModal(fastRecovery));
    }

    if (viewMode === ViewMode.SETUP_WIZARD) {
      dispatch(setWizardFlag(WizardFlag.ERROR));
      dispatch(setStepDataByName(SetupWizardStep.PLATE_COPY_PROTOCOL, {isSkippable: true, isStepProcessed: false}));
    }
  });

  hubObject.on(SignalREvent.ERROR_ON_IDLE_TRIGGERED, async (res) => {
    console.info('event received:', SignalREvent.ERROR_ON_IDLE_TRIGGERED);
    console.log(SignalREvent.ERROR_ON_IDLE_TRIGGERED, res);

    const isInstumentIdle = await dispatch(checkIsInstrumentIdle(true));

    if (!isInstumentIdle) return;

    // show motor skip modal when instrument in idle position
    await dispatch(setErrorCodeNumber(FastRobotErrorcode.ActuatorFollowingErrorIdle));
    dispatch(showMotorSkipModal(fastRecovery));
  });

  hubObject.on(SignalREvent.LOAD_CELL_ERROR, async (res) => {
    const {appState} = getState();
    const {viewMode} = appState;

    console.info('event received:', SignalREvent.LOAD_CELL_ERROR);
    console.log(SignalREvent.LOAD_CELL_ERROR, res);

    await dispatch(setErrorCodeNumber(res.fastErrorCode));
    dispatch(
      showLoadCellErrorModal(() => {
        if (viewMode === ViewMode.SETUP_WIZARD) {
          dispatch(changeView(ViewMode.EXPLORER));
        }
      }, res.fastErrorCode),
    );
  });

  hubObject.on(SignalREvent.LICENSE_ACTIVATED, (res) => {
    console.info('event received:', SignalREvent.LICENSE_ACTIVATED);
    console.log(SignalREvent.LICENSE_ACTIVATED, res);

    const {licenseState} = getState();
    const {isTessaraInstrument: prevIsTessaraInstrument} = licenseState;
    const {isTessaraInstrument: newIsTessaraInstrument} = res;

    dispatch(setLicense(res));

    if (prevIsTessaraInstrument && !newIsTessaraInstrument) {
      dispatch(kickUser(null, false));
    }
  });

  hubObject.on(SignalREvent.USER_CONFIRMATION_DIALOG, (res) => {
    console.info('event received:', SignalREvent.USER_CONFIRMATION_DIALOG);
    console.log(SignalREvent.USER_CONFIRMATION_DIALOG, res);

    const {cardState, appState, runtimeState} = getState();
    const {tasks} = cardState;
    const {viewMode} = appState;
    const {readOnly} = runtimeState;

    dispatch(setInstrumentStatus(InstrumentStatusType.NEED_USER_ATTENTION));

    if (!readOnly && viewMode === ViewMode.RUNTIME) {
      dispatch(hideLoading());
      dispatch(showRuntimeUserActionModalByTaskType(TaskType.USER_CONFIRMATION, tasks[res]));
    }
  });

  hubObject.on(SignalREvent.DELAY_DIALOG, (res) => {
    console.info('event received:', SignalREvent.DELAY_DIALOG);
    console.log(SignalREvent.DELAY_DIALOG, res);

    const {cardState, appState, runtimeState} = getState();
    const {tasks} = cardState;
    const {viewMode} = appState;
    const {readOnly} = runtimeState;

    dispatch(setInstrumentStatus(InstrumentStatusType.NEED_USER_ATTENTION));

    if (!readOnly && viewMode === ViewMode.RUNTIME) {
      dispatch(showRuntimeUserActionModalByTaskType(TaskType.DELAY, tasks[res]));
    }
  });

  hubObject.on(SignalREvent.PLATE_SWAPPED, async (response) => {
    console.info('event received:', SignalREvent.PLATE_SWAPPED);
    console.log(SignalREvent.PLATE_SWAPPED, response);
    const {labwareState} = getState();
    const newLabwareState = jsonCopy(labwareState);
    for (let iPayload = 0; iPayload < response.length; iPayload += 1) {
      const {currentPosition, suggestedPosition} = response[iPayload];
      newLabwareState[suggestedPosition.position] = labwareState[currentPosition.position];
    }
    dispatch(setLabwareState(newLabwareState));
    dispatch(updateLabwareCurrentRunProtocol(newLabwareState));
  });

  // AutoCalibrationExecuteDone will trigger after auto calibration execution is done
  hubObject.on(SignalREvent.AUTO_CALIBRATION_EXECUTE_DONE, async (response) => {
    console.info('event received:', SignalREvent.AUTO_CALIBRATION_EXECUTE_DONE);
    console.log(response);
    const {appState} = getState();
    const {viewMode} = appState;
    const {isExecutor} = await dispatch(checkOngoingCalibration());
    const callback = (res) => {
      if (viewMode === ViewMode.SETUP_WIZARD) {
        dispatch(handleSWizardAutoCalibrationResponse(res));
      } else {
        dispatch(handleTrayCalibrationErrorResponse(res));
      }
    };

    if (!response || !isExecutor || (viewMode !== ViewMode.SETUP_WIZARD && viewMode !== ViewMode.TRAY_CALIBRATION))
      return;

    if (response.errorCode !== FastRobotErrorcode.ActuatorEmergencyStop) await dispatch(hideModal());
    // to avoid delay on showing success check mark after loading in setup wizard,
    // the hideLoading func is being called in setup wizard's auto calibration handler func
    if (viewMode !== ViewMode.SETUP_WIZARD) dispatch(hideLoading());

    await dispatch(setTrayCalibrationResult(response));
    dispatch(autoCalibrationErrorHandler(response, onAutoCalibration, callback));
  });

  hubObject.on(SignalREvent.AUTO_A1_OFFSET_CALIBRATION_EXECUTION_DONE, async (response) => {
    console.info('event received:', SignalREvent.AUTO_A1_OFFSET_CALIBRATION_EXECUTION_DONE);
    console.log(response);

    const {viewMode} = getState().appState;
    const {a1Offset, a1OffsetCalibrateDateTime, isAborted} = response || {};

    const isExecutor = await dispatch(isTipsPickupCalibrationExecutor());
    if (!isExecutor) return;

    if (isAborted) {
      dispatch(showTipsPickupCalibrationAbortedToast());
      return;
    }

    dispatch(hideLoading());

    batch(() => {
      dispatch(setTipsPickupPosition(a1Offset));
      dispatch(setTipsPickupLastCalibratedDate(new Date(a1OffsetCalibrateDateTime).toLocaleDateString()));
      dispatch(setTipsPickupIsRecentlyCalibrated(true));
      dispatch(showSnackbar(Feedback.SUCCESS, parseMessage('tipsPickupCalibration.toast.success')));

      if (viewMode === ViewMode.SETUP_WIZARD) {
        dispatch(setCurrentStepAsProcessed());
      }
    });

    await dispatch(handleSetMarkerPositionAfterUpdateA1());
  });

  hubObject.on(SignalREvent.AUTO_A1_OFFSET_CALIBRATION_ERROR_ENCOUNTERED, async (response) => {
    console.info('event received:', SignalREvent.AUTO_A1_OFFSET_CALIBRATION_ERROR_ENCOUNTERED);
    console.log(response);

    const isExecutor = await dispatch(isTipsPickupCalibrationExecutor());

    if (!isExecutor) return;

    async function callback() {
      await dispatch(fastRecovery());
      await dispatch(runAutoA1OffsetCalibrationAndShowLoading());
    }

    const {errorCode} = response || {};

    dispatch(hideLoading());
    dispatch(setTipsPickupIsRecentlyCalibrated(false));

    dispatch(tipsPickupCalibrationErrorHandler(errorCode, callback));
  });

  // #region manual reteach plate
  hubObject.on(SignalREvent.MANUAL_RETEACH_PLATE_SCANNING_TIPS_DONE, async (response) => {
    console.log('event : ', SignalREvent.MANUAL_RETEACH_PLATE_SCANNING_TIPS_DONE);
    console.log(response);

    const {isExecutor} = await dispatch(checkOngoingManualReteachProcess());
    if (!isExecutor) return;

    const {currentPosition, errorCode} = response;
    if (errorCode !== FastRobotErrorcode.NoError) {
      dispatch(manualReteachErrorHandler(errorCode, response));
      dispatch(hideLoading());
      return;
    }

    batch(() => {
      dispatch(openManualReteachPage(currentPosition));
      dispatch(hideLoading());
    });
  });

  hubObject.on(SignalREvent.MANUAL_RETEACH_PLATE_RETURN_TIPS_DONE, async (response) => {
    const {typedModalState} = getState();
    const {data} = typedModalState;
    console.log('event : ', SignalREvent.MANUAL_RETEACH_PLATE_RETURN_TIPS_DONE);
    console.log(response);

    const {parentMicroplate, childMicroplates, errorCode} = response;
    if (errorCode !== FastRobotErrorcode.NoError) {
      // dispatch(fastRuntimeErrorResHandling(errorCode));
      dispatch(manualReteachErrorHandler(errorCode));
      dispatch(hideLoading());
      dispatch(setSelectedWellStyle({}));
      return;
    }

    if (data?.saveChanges) {
      // TODO save the labware
      let respSave = await dispatch(updateLabwareDefinition(parentMicroplate.definition));
      console.log(respSave);
      if (respSave.errorCode === FastRobotErrorcode.NoError && childMicroplates?.length > 0) {
        const promises = childMicroplates.map(async (microplate) => {
          respSave = await dispatch(updateLabwareDefinition(microplate?.definition));
        });

        await Promise.all(promises);
      }

      batch(() => {
        dispatch(exitPlateTypeEditor());
      });
      dispatch(setSelectedWellStyle({}));
      dispatch(hideLoading());
      return;
    }

    if (data?.closeButtonClick) {
      dispatch(exitPlateTypeEditor());
    } else {
      dispatch(resetIsManualReteachPage());
    }
    dispatch(setSelectedWellStyle({}));
    dispatch(hideLoading());
  });
  // #endregion manual reteach plate

  // #region Auto A1 Offset Calibration Progress Update
  hubObject.on(SignalREvent.AUTO_A1_OFFSET_CALIBRATION_PROGRESS_UPDATE, async (response) => {
    console.info('event received:', SignalREvent.AUTO_A1_OFFSET_CALIBRATION_PROGRESS_UPDATE);
    console.log(response);

    const {viewMode} = getState().appState;
    const {progressPercentage} = response || {};

    if (viewMode === ViewMode.SETUP_WIZARD || viewMode === ViewMode.TIPS_PICKUP_CALIBRATION) {
      dispatch(setAutoA1OffsetCalibrationProgress(progressPercentage));
    }
  });
  // #endregion Auto A1 Offset Calibration Progress Update

  hubObject.on(SignalREvent.PLATE_RECOGNITION_STATE_CHANGED, async (response) => {
    dispatch(setIsPlateRecognitionEnabled(response));
  });
};

export const unsubscribeEvent = (hubObject) => () => {
  const events = [
    SignalREvent.VISION_SCAN_DONE,
    SignalREvent.VISION_SCAN_TRAY_DONE,
    SignalREvent.PROTOCOL_CALCULATION_DONE,
    SignalREvent.SET_PROTOCOL_TIP,
    SignalREvent.PERCENT_PROGRESS_BAR_UPDATE,
    SignalREvent.PROGRESS_UPDATE,
    SignalREvent.DELAY_DIALOG,
    SignalREvent.USER_CONFIRMATION_DIALOG,
    SignalREvent.RUNTIME_ERROR,
    SignalREvent.PAUSE_PROTOCOL_START,
    SignalREvent.PAUSE_PROTOCOL_END,
    SignalREvent.RESUME_PROTOCOL_START,
    SignalREvent.RESUME_PROTOCOL_END,
    SignalREvent.ABORT_PROTCOL_START,
    SignalREvent.PROTOCOL_DONE,
    SignalREvent.EXECUTION_DONE,
    SignalREvent.CLOSE_RUNTIME_VIEW,
    SignalREvent.NEW_RUN_SESSION,
    SignalREvent.PRE_RUN_PROTOCOL_CONFIRMATION,
    SignalREvent.TRAY_DETACHED,
    SignalREvent.TRAY_ATTACHED,
    SignalREvent.TRAY_ATTACHED_HANDLING_DONE,
    SignalREvent.EMERGENCY_STOP_TRIGGERED,
    SignalREvent.ERROR_ON_IDLE_TRIGGERED,
    SignalREvent.AUTO_CALIBRATION_EXECUTE_DONE,
    SignalREvent.AUTO_A1_OFFSET_CALIBRATION_EXECUTION_DONE,
    SignalREvent.AUTO_A1_OFFSET_CALIBRATION_ERROR_ENCOUNTERED,
    SignalREvent.LOAD_CELL_ERROR,
    SignalREvent.AUTO_A1_OFFSET_CALIBRATION_PROGRESS_UPDATE,
    SignalREvent.PLATE_RECOGNITION_STATE_CHANGED,
  ];
  events.forEach((event) => {
    hubObject.off(event);
  });
};
